export enum FilesTypeEnum {
  Video = 1,
  Image = 2,
  General = 3,
  Pdf = 4,
}
